export function onlyNumber(event) {
    const isSpecial = event.which === 8 || event.which === 0 || event.which === 9 || event.which === 37 || event.which === 39 || event.which === 46;

    if (event.target.value.length > 6 && !isSpecial) {
        event.preventDefault();
    }
    if (!isSpecial && (event.which < 48 || event.which > 57)) {
        event.preventDefault();
    }
}


export function onlyDecimalNumber(inputText, event) {
    let str = String(inputText);
    let con = -1;

    if (event.which === 46) {
        for (let i = 0; i < str.length; i++) {
            if (str.charAt(i) === ".") {
                con++;
            }
        }

        if (con === 0) {

            event.preventDefault();
        }
        
    }
    const isSpecial = event.which === 8 || event.which === 0;
    
    if (event.target.value.length > 6 && !isSpecial) {
        event.preventDefault();
    }

    if (!isSpecial && (event.which < 48 || event.which > 57) && event.which !== 46) {
        event.preventDefault();
    }
}
export function isDecimal(inputText, event) {
    let regex = /^[-+]?[0-9]+\.[0-9]+$/;
    return (regex.test(inputText));
}

export function onlyLetter(event, max) {

    let key = event.keyCode || event.which;
    let tecla = String.fromCharCode(key).toLowerCase();
    let letras = `\u00e1\u00e9\u00ed\u00f3\u00fa\u00f1abcdefghijklmnopqrstuvwxyz "`;
    let especiales = [8, 9, 37, 39, 46, 199, 42, 229, 221, 16, 94, 168];

    let tecla_especial = especiales.includes(key);

    if (letras.indexOf(tecla) === -1 && !tecla_especial) {
        event.preventDefault();
    }

    if (event.target.value.length > max && !tecla_especial) {
        event.preventDefault();
    }
}


export function onlyLetterNumber(event) {

    let key = event.keyCode || event.which;
    let tecla = String.fromCharCode(key).toLowerCase();
    let letras = `\u00e1\u00e9\u00ed\u00f3\u00fa\u00f1abcdefghijklmnopqrstuvwxyz0123456789`;
    let especiales = [8, 9, 37, 39, 46, 199, 42, 229, 221, 16, 94, 168];

    let tecla_especial = especiales.includes(key);

    if (letras.indexOf(tecla) === -1 && !tecla_especial) {
        event.preventDefault();
    }
}

export function maxLengthLimitInput(event, max, type = '') {

    let key = event.keyCode || event.which;
    let tecla = String.fromCharCode(key).toLowerCase();
    let letras = "";

    switch (type) {
        case 'email':
            letras = `\u00e1\u00e9\u00ed\u00f3\u00fa\u00f1abcdefghijklmnopqrstuvwxyz0123456789.@!#$%&'*/=?^_+-|{~}`;
            break;
        case 'curp':
            letras = `\u00e1\u00e9\u00ed\u00f3\u00fa\u00f1abcdefghijklmnopqrstuvwxyz0123456789`;
            break;
        case 'rfc':
            letras = `\u00e1\u00e9\u00ed\u00f3\u00fa\u00f1abcdefghijklmnopqrstuvwxyz0123456789`;
            break;
        case 'razon_social':
            letras = `\u00e1\u00e9\u00ed\u00f3\u00fa\u00f1abcdefghijklmnopqrstuvwxyz0123456789,. `;

            break;
        default:


    }


    let especiales = [8, 9, 37, 39, 46, 199, 42, 229, 221, 16, 94, 168];

    let tecla_especial = especiales.includes(key);

    if (event.target.value.length > max && !tecla_especial) {
        event.preventDefault();
    }

    if (letras.indexOf(tecla) === -1 && !tecla_especial) {
        event.preventDefault();
    }
}

export function onlyNumberLinea(event) {
    const isSpecial = event.which === 8 || event.which === 0 || event.which === 9 || event.which === 37 || event.which === 39 || event.which === 46;

    if (event.target.value.length > 19 && !isSpecial) {
        event.preventDefault();
    }
    if (!isSpecial && (event.which < 48 || event.which > 57)) {
        event.preventDefault();
    }
}

export const emailValidation = (email) => {
    const regEx = /^[^\s@]{1,100}@[^\s@]{1,50}\.[^\s@]{1,50}$/;
    return regEx.test(email.toLowerCase());
};

export const curpValidation = (curp) => {
    const regEx = /^[A-Z]{4}\d{6}[HM][A-Z]{5}[0-9A-Z]\d$/;
    const dictionary = "0123456789ABCDEFGHIJKLMNÑOPQRSTUVWXYZ";
    const normalizedCurp = curp.toUpperCase();

    if (!regEx.test(normalizedCurp)) {
        return false;
    }

    const sum = normalizedCurp
        .slice(0, 17)
        .split("")
        .reduce((total, character, index) => {
            return total + dictionary.indexOf(character) * (18 - index);
        }, 0);
    const checkDigit = (10 - (sum % 10)) % 10;

    return checkDigit === Number(normalizedCurp.charAt(17));
};

export function onlyNumberPhone(event) {
    const isSpecial = event.which === 8 || event.which === 0 || event.which === 9 || event.which === 37 || event.which === 39 || event.which === 46;

    if (event.target.value.length > 9 && !isSpecial) {
        event.preventDefault();
    }
    if (!isSpecial && (event.which < 48 || event.which > 57)) {
        event.preventDefault();
    }
}



export const toMexico = (number) => {
  const num = Number(
    number.toString().replaceAll("$", "").replaceAll(" ", "").replaceAll(",", "")
  );

  return new Intl.NumberFormat("es-MX", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
};

export const removeEmojis = (text) => {
    if (!text) return text;
    return text.replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]|\u2600-\u26FF|\u2700-\u27BF/g, "");
};
